require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/common/responseTO.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/common/responseTO.legacy.js
// module id = 622
// module chunks = 31